module.exports = __webpack_public_path__ + "static/media/computer-icon.0c32a620.svg";